import i18n from "../i18n";
import React, { useState, useEffect } from "react";
import { IconTrash, IconPencil, IconSettings, IconFilter } from "@tabler/icons";
import {
  Card,
  Group,
  Title,
  Text,
  Grid,
  Accordion,
  Button,
  Checkbox,
  Divider,
} from "@mantine/core";
import { ScrollArea } from "@mantine/core";
import { useServerApi } from "../hooks/userServerApi";
import { useForceUpdate } from "@mantine/hooks";

const ProductFilter = ({ onChange }) => {
  const [api] = useServerApi();
  const [filters, setFilters] = useState({
    types: [],
    category: [],
    providers: [],
  });
  const [filtersCount, setFiltersCount] = useState(0);

  const forceUpdate = useForceUpdate();
  const [types, setTypes] = useState([]);

  const fetchFilters = async () => {
    const f = {
      types: [],
      category: [],
      providers: [],
    };

    const rtypes = await api.search({
      apiEntity: "productType",
      pageSize: 100,
      sort: { by: "name", order: "asc" },
    });

    const types = rtypes.docs;
    types.forEach((t) => (t.checked = true));
    f.types = types;
    setTypes(types);

    const rcategory = await api.search({
      apiEntity: "productCategory",
      pageSize: 100,
      // sort: { by: "name", order: "asc" },
    });

    f.category = rcategory.docs;
    f.category.forEach((t) => (t.checked = true));

    const rproviders = await api.search({
      apiEntity: "provider",
      pageSize: 200,
      sort: { by: "name", order: "asc" },
    });

    f.providers = rproviders.docs;
    f.providers.forEach((t) => (t.checked = true));

    setFilters(f);
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  const filterLabelSpacing = 150;

  const handleFilterReset = () => {
    fetchFilters();
  };

  const handleFilterSearch = () => {
    const query = {};

    const checkedTypes = filters.types.filter((f) => f.checked);
    const checkedCat = filters.category.filter((f) => f.checked);
    const checkedProviders = filters.providers.filter((f) => f.checked);

    if (filters.types.length !== checkedTypes.length) {
      query.type = {
        _id: {
          $in: checkedTypes.map((t) => t._id),
        },
      };
      //   query.type = {
      //     $in: checkedTypes.map((t) => t._id),
      //   };
    }

    if (filters.category.length !== checkedCat.length) {
      query.category = {
        _id: { $in: checkedCat.map((t) => t._id) },
      };
    }

    if (filters.providers.length !== checkedProviders.length) {
      query.provider = {
        _id: { $in: checkedProviders.map((t) => t._id) },
      };
    }
    setFiltersCount(
      checkedCat.length + checkedProviders.length + checkedTypes.length
    );
    if (onChange) onChange(query);
  };
  return (
    <Accordion defaultValue={null} mb={"xl"} variant="separated" c>
      <Accordion.Item value="Filters">
        <Accordion.Control>
          <Group>
            <IconFilter size={15} color="gray" />
            <Text size="xs">Filters ({filtersCount}) </Text>
          </Group>
        </Accordion.Control>
        <Accordion.Panel>
          {/* <FormSection> */}
          <Divider mb="sm"></Divider>
          <Group spacing={"xl"} mb="md">
            <Text size={"xs"} miw={filterLabelSpacing}>{i18n.t("Category")}</Text>
            <Group>
              {filters?.category.map((cat) => (
                <Checkbox
                  label={cat.name}
                  key={cat._id}
                  checked={cat.checked}
                  size="xs"
                  onChange={(event) => {
                    cat.checked = event.currentTarget.checked;

                    const checkedCat = filters.category
                      .filter((cat) => cat.checked)
                      .map((cat) => cat._id);

                    filters.types = types.filter((t) =>
                      checkedCat.includes(t.category._id)
                    );

                    setFilters({ ...filters });
                  }}
                />
              ))}
            </Group>
          </Group>
          {/* <Divider mb="sm"></Divider> */}

          <Group spacing={"xl"} mb="md" align="flex-start">
            <div>
              <Text size={"xs"} miw={filterLabelSpacing}>{i18n.t("Type")}</Text>
              <Group mb={"sm"}>
                <Text
                  size={9}
                  onClick={() => {
                    filters.types.forEach((t) => (t.checked = false));
                    forceUpdate();
                  }}
                  style={{ cursor: "pointer" }}
                >{i18n.t("Clear All")}</Text>
                <Text size={9}>|</Text>
                <Text
                  size={9}
                  onClick={() => {
                    filters.types.forEach((t) => (t.checked = true));
                    forceUpdate();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Select All
                </Text>
              </Group>
            </div>

            <ScrollArea
              w={300}
              h={200}
              style={{
                border: "1px solid grey ",
                borderRadius: 5,
                padding: 10,
              }}
            >
              {filters?.types.map((type) => (
                <Checkbox
                  label={type.name}
                  key={type._id}
                  checked={type.checked}
                  size="xs"
                  mb={"sm"}
                  onChange={(event) => {
                    type.checked = event.currentTarget.checked;
                    setFilters({ ...filters });
                  }}
                />
              ))}
            </ScrollArea>
          </Group>
          {/* <Divider mb="sm"></Divider> */}

          <Group spacing={"xl"} mb="md" align="flex-start">
            <div>
              <Text size={"xs"} miw={filterLabelSpacing}>{i18n.t("Provider")}</Text>
              <Group mb={"sm"}>
                <Text
                  size={9}
                  onClick={() => {
                    filters.providers.forEach((t) => (t.checked = false));
                    forceUpdate();
                  }}
                  style={{ cursor: "pointer" }}
                >{i18n.t("Clear All")}</Text>
                <Text size={9}>|</Text>
                <Text
                  size={9}
                  onClick={() => {
                    filters.providers.forEach((t) => (t.checked = true));
                    forceUpdate();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Select All
                </Text>
              </Group>
            </div>

            <ScrollArea
              w={300}
              h={200}
              style={{
                border: "1px solid grey ",
                borderRadius: 5,
                padding: 10,
              }}
            >
              {filters?.providers.map((provider) => (
                <Checkbox
                  label={
                    provider.shortName ? provider.shortName : provider.name
                  }
                  key={provider._id}
                  checked={provider.checked}
                  size="xs"
                  mb={"sm"}
                  onChange={(event) => {
                    provider.checked = event.currentTarget.checked;
                    setFilters({ ...filters });
                  }}
                />
              ))}
            </ScrollArea>

            {/* <Group>
                       
                            {filters?.providers.map((provider) => (
                                <Checkbox
                                    label={provider.name}
                                    key={provider._id}
                                    checked={provider.checked}
                                    size="xs"
                                    onChange={(event) => {
                                        provider.checked =
                                            event.currentTarget.checked;
                                        setFilters({ ...filters });
                                    }}
                                />
                            ))}
                        </Group> */}
          </Group>
          <Group mt={50}>
            <Button size="xs" onClick={handleFilterSearch} variant="default">{i18n.t("Search")}</Button>
            <Button size="xs" onClick={handleFilterReset} variant="default">
              Reset
            </Button>
          </Group>
          {/* </FormSection> */}
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default ProductFilter;
